import { User } from 'shell/models/user';

export interface UserProfile {
  datiLogin?: User;
  isLoading?: boolean;
  stateLoginModal?: boolean | undefined;
}

export interface UserProfileContext {
  userProfile: UserProfile;
  setUserProfile: (a?: User) => UserProfile;
  openLoginModal?: (open: boolean) => void;
}

export enum SessionManagementEnum {
  Storage = 'storage',
  State = 'state',
}
